// currency cannot duplicated in PF_INFO
export const PF_INFO = [
    {
        pfID: 'ac',
        currency: 'CNY',
    },
    {
        pfID: 'acvnd',
        currency: 'VND',
    },
    {
        pfID: 'acthb',
        currency: 'THB',
    },
    {
        pfID: 'acphp',
        currency: 'PHP',
    },
    {
        pfID: 'pusd',
        currency: 'USD',
    },
    {
        pfID: 'pinr',
        currency: 'INR',
    },
    {
        pfID: 'pidr',
        currency: 'IDR',
    },
    {
        pfID: 'pmyr',
        currency: 'MYR',
    },
    {
        pfID: 'pusdt',
        currency: 'USDT',
    },
    {
        pfID: 'pbdt',
        currency: 'BDT',
    },
    {
        pfID: 'pmmko',
        currency: 'MMKO',
    },
    {
        pfID: 'pmmk',
        currency: 'MMK',
    },
    {
        pfID: 'ptnd',
        currency: 'TND',
    },
    {
        pfID: 'pbrl',
        currency: 'BRL',
    },
    {
        pfID: 'ptry',
        currency: 'TRY',
    },
    {
        pfID: 'phkd',
        currency: 'HKD',
    },
    {
        pfID: 'pmxn',
        currency: 'MXN',
    },
    {
        pfID: 'pmyrh',
        currency: 'MYRH',
    },
    {
        pfID: 'pthbt',
        currency: 'THBT',
    },
    {
        pfID: 'pvndo',
        currency: 'VNDO',
    },
    {
        pfID: 'pnpr',
        currency: 'NPR',
    }, 
    {
        pfID: 'paud',
        currency: 'AUD',
    }, 
    {
        pfID: 'pkes',
        currency: 'KES',
    },
    {
        pfID: 'pngn',
        currency: 'NGN',
    },
    {
        pfID: 'pamd',
        currency: 'AMD',
    },
    {
        pfID: 'ppkr',
        currency: 'PKR',
    },
    {
        pfID: 'pzar',
        currency: 'ZAR',
    },
    {
        pfID: 'pjpy',
        currency: 'JPY',
    },
    {
        pfID: 'pkrw',
        currency: 'KRW',
    },
    {
        pfID: 'pxin',
        currency: 'XIN',
    },
    {
        pfID: 'plkr',
        currency: 'LKR',
    },
    {
        pfID: 'ptzs',
        currency: 'TZS',
    },
    {
        pfID: 'pgbp',
        currency: 'GBP',
    },
    {
        pfID: 'peur',
        currency: 'EUR',
    },
    {
        pfID: 'pclp',
        currency: 'CLP',
    },
    {
        pfID: 'petb',
        currency: 'ETB',
    },
    {
        pfID: 'pidro',
        currency: 'IDRO',
    },
    {
        pfID: 'prub',
        currency: 'RUB',
    },
    {
        pfID: 'pcad',
        currency: 'CAD',
    },
    {
        pfID: 'dmyr',
        currency: 'DMYR',
    },
    {
        pfID: 'dmyrh',
        currency: 'DMYRH',
    },
    {
        pfID: 'dphp',
        currency: 'DPHP',
    },
    {
        pfID: 'dinr',
        currency: 'DINR',
    },
    {
        pfID: 'dbdt',
        currency: 'DBDT',
    },
    {
        pfID: 'plak',
        currency: 'LAK',
    },
    {
        pfID: 'plako',
        currency: 'LAKO',
    },

    {
        pfID: 'paed',
        currency: 'AED',
    },
    {
        pfID: 'pbnd',
        currency: 'BND',
    },
    {
        pfID: 'pars',
        currency: 'ARS',
    },
    {
        pfID: 'pghs',
        currency: 'GHS',
    },
    {
        pfID: 'pegp',
        currency: 'EGP',
    },
    {
        pfID: 'pkhr',
        currency: 'KHR',
    },
    {
        pfID: 'pkhro',
        currency: 'KHRO',
    },
    {
        pfID: 'pcop',
        currency: 'COP',
    },
    {
        pfID: 'ppgk',
        currency: 'PGK',
    },
    {
        pfID: 'ppen',
        currency: 'PEN',
    },
    {
        pfID: 'maud',
        currency: 'MAUD',
    },
    {
        pfID: 'dmaud',
        currency: 'DMAUD',
    },
]

// for checking currency of test platform
export const DEV_PF_INFO = [
    {
        pfID: 'guest',
        currency: 'CNY',
    },
    {
        pfID: 'ze',
        currency: 'VND',
    },
]

export const PUBLIC_SUB_PF_ID = 'public'

// 試玩幣別
const TRIAL_COINS = [ 'dmyr', 'dmyrh', 'dphp', 'dinr', 'dbdt', 'dmaud']

// platform(currency) list customized sort - 試玩幣別排序皆往後放
export const PLATFORM_SORT = ['acthb', 'ac', 'acvnd', 'acphp', 'pidr', 'pinr', 'pusd', 'pmyr', 'pmyrh', 'pusdt', 'pmmk', 'phkd', 'pnpr', 'pbdt', 'pmxn', 'ptnd', 'pthbt', 'pmmko', 'pvndo', 'ptry', 'pbrl', 'paud', 'pkes', 'pngn', 'pamd', 'ppkr', 'pzar', 'pjpy', 'pkrw', 'pxin', 'plkr', 'ptzs', 'pgbp', 'peur', 'pclp', 'petb', 'pidro', 'prub', 'pcad', 'plak', 'plako', 'paed', 'pbnd', 'pars', 'pghs', 'pegp', 'pkhr', 'pkhro', 'pcop', 'ppgk', 'ppen', 'maud', ...TRIAL_COINS]
